<template>
  <li class="nav-item">
    <a class="nav-link"><span class="icon-user-tie"></span><span class="Logout__name">{{ user.username }}</span></a>
  </li>
  <li class="nav-item">
    <a class="nav-link" href="#" @click.prevent="logout" >Déconnexion</a>
  </li>
</template>

<script>
  import { authenticatedUser as user, userAuthenticated } from 'src/vuex/getters'
  import { getAuthenticatedUser, logout as vuexLogout } from 'src/vuex/actions/authActions'

  export default{
    vuex: {
      actions: { getAuthenticatedUser, vuexLogout },
      getters: { user, userAuthenticated }
    },
    watch: {
      'userAuthenticated' (value) {
        if (value === true) {
          this.getAuthenticatedUser()
        }
      }
    },
    methods: {
      logout () {
        this.vuexLogout()
        this.$router.go('/login')
      }
    },
    ready () {

    }
  }
</script>

<style lang="scss" scoped>
  .Logout{
  }
  .Logout__name{
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// Logout.vue?533f2cd6